import React, { useState, useEffect } from 'react';
import { Button, Modal, ModalHeader, ModalBody, Spinner, Alert, Form, Col, Row, } from 'reactstrap';

import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import { addNewFuelSupply, getFuelSupplyList, getFuelSupplyListFilter, getFuelSupplyTypeCode, getFuelTank, getProductiveCycleActive, updateFuelSupply } from '../../../../slices/thunks';
import { setRequireCloseModal } from '../../../../slices/fuelSupply/reducer';
import OSelect from '../../../../Components/OElements/OSelect';
import { getFuelTankList } from '../../../../helpers/establishment/backend_helper';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';

const ReceiveFuelSupplyModal = ({ dataFuelSupply, isOpen, handlerToggleModal, establishment_id }) => {
	const dispatch = useDispatch();

	const selectorFuelSupplyTypeCode = createSelector(
		state => state.FuelSupplyType,
		data => ({
			itemFuelSupplyTypeDetail: data.itemFuelSupplyTypeDetail,
		})
	);
	const { itemFuelSupplyTypeDetail } = useSelector(selectorFuelSupplyTypeCode);



	const selectorFuelTank = createSelector(
		state => state.FuelTank,
		data => ({
			itemFuelTankDetail: data.itemFuelTankDetail,
			requireCloseModal: data.requireCloseModal,
			isAdding: data.isAdding,
		})
	);
	const { itemFuelTankDetail, requireCloseModal, isAdding } = useSelector(selectorFuelTank);

	useEffect(() => {
		dispatch(getFuelTank(dataFuelSupply.fuel_tank_id));
	}, [dataFuelSupply]);

	const selectorEstablishments = createSelector(
		state => state.Establishments,
		establishment => ({
			productive_cycle: establishment.productiveCycleActiveDetail,
		})
	);
	const { productive_cycle } = useSelector(selectorEstablishments);


	useEffect(() => {
		if (isOpen) {
			if (requireCloseModal) {
				dispatch(setRequireCloseModal(false));
				handlerToggleModal();
			}
		}
	}, [requireCloseModal]);




	const [isLoading, setIsLoading] = useState(false);
	const [fuelTank, setFuelTank] = useState(null);
	const validation = useFormik({
		enableReinitialize: true,
		initialValues: {
			fuel_tank_id: (dataFuelSupply && dataFuelSupply.fuel_tank_id) || '',
		},
		validationSchema: Yup.object({
			fuel_tank_id: Yup.string().required('Campo requerido'),
		}),
		onSubmit: async (values) => {
			setIsLoading(true);
			handlerReceive(fuelTank.stock)
		},
	});

	const handleFuelTankSelect = (optionSelected) => {
		setFuelTank(optionSelected)
	};


	async function handlerReceive(stock) {

		const fuel_supply_type = await dispatch(getFuelSupplyTypeCode('input_transfer'));
		const productive_cycle = await dispatch(getProductiveCycleActive(establishment_id));

		const fuelSupplyAdd = {
			amount: dataFuelSupply.amount,
			supply_date: Date.now(),
			fuel_tank_id: fuelTank._id,
			fuel_type_id: fuelTank.fuel_type_id,
			fuel_supply_type_id: fuel_supply_type.payload._id,
			observation: dataFuelSupply.observation,

			productive_cycle_id: productive_cycle.payload._id,
			feeding_barges_id: productive_cycle.payload.feeding_barges_id,

			establishment_id: establishment_id,
			stock: stock,
			balance: stock + dataFuelSupply.amount,
			unit_measurement_id: dataFuelSupply.unit_measurement_id,
			transfer_company_id: dataFuelSupply.transfer_company_id,
			transfer_id: dataFuelSupply.transfer_id,
			file_type_id: dataFuelSupply.file_type_id,
			transfer_establishment_id: dataFuelSupply.establishment_id,
			file_id: dataFuelSupply.file_id,
			document_number: dataFuelSupply.document_number,
			fuel_type_id: dataFuelSupply.fuel_type_id
		}

		await dispatch(addNewFuelSupply(fuelSupplyAdd));

		const fuelSupplyUpdate = { ...dataFuelSupply };
		fuelSupplyUpdate.received = true;



		await dispatch(updateFuelSupply(fuelSupplyUpdate));
		await dispatch(getFuelSupplyList({ establishment_id: establishment_id }));
		await dispatch(getFuelSupplyListFilter({ transfer_establishment_id: dataFuelSupply.transfer_establishment_id, fuel_supply_type_id: dataFuelSupply.fuel_supply_type_id, received: false }));
		handlerToggleModal();
		setIsLoading(false);
	}


	return (
		<div>
			<Modal
				isOpen={isOpen}
				toggle={() => handlerToggleModal()}
				size='sm'
				className='border-0'
				modalClassName='modal fade zoomIn'
				backdrop={'static'}
				centered={true}
			>
				<ModalHeader className='modal-title' />
				<ModalBody className='text-center p-3'>



					<Form
						className='tablelist-form'
						onSubmit={e => {
							e.preventDefault();
							validation.handleSubmit();
							return false;
						}}
					>

						<lord-icon
							src='https://cdn.lordicon.com/tdrtiskw.json'
							trigger='loop'
							colors='primary:#f06548,secondary:#405189'
							style={{ width: '90px', height: '90px' }}
						></lord-icon>
						<div className='mt-2'>
							<h3 className='mb-3'>
								¿Estas seguro de recepcionar esta cantidad de combustible?
							</h3>

							<Row className='g-3'>
								<Col lg={12}>
									<OSelect
										key={'fuel_tank_id'}
										label='Estanque de Combustible'
										id='fuel_tank_id'
										name='fuel_tank_id'
										isRequired={true}
										onSelect={handleFuelTankSelect}
										requestApi={() => getFuelTankList({ 'establishment_id': establishment_id, 'fuel_type_id': dataFuelSupply.fuel_type_id })}
										validation={validation}
									/>
								</Col>
							</Row>



							<p className='text-muted mb-4'>
								Si deseas realizar esta acción debes hacer click en
								confirmar.
							</p>
							<p className='small'>
								Registro de Combustible: {dataFuelSupply !== null ? dataFuelSupply?.amount + ' ' + dataFuelSupply?.unit_measurement?.name : ''}
							</p>
							<div className='hstack gap-2 justify-content-center'>
								<Button className='btn-danger btn-label' onClick={() => handlerToggleModal()}><i className='icon-x label-icon'></i> Cancelar</Button>
								<button type='submit' className='btn btn-label btn-primary' id='add-btn' disabled={isLoading}>{isLoading ? (<i className='label-icon'><Spinner size='sm' /></i>) : <i className={`${Icons.check2} label-icon`}></i>} Confirmar</button>
							</div>
						</div>

					</Form>

				</ModalBody>
			</Modal>
		</div>
	);
};

export default ReceiveFuelSupplyModal;
